export function isRunningInIframe(): boolean {
	try {
		if (typeof window === 'undefined') return false;
		return window.self !== window.top;
	} catch {
		// Cross-origin parent — access to window.top is blocked, which means we're in an iframe
		return true;
	}
}

/** Drops query params from the live URL in place, no navigation. Use this over
 *  `router.replace` for cleanups: replace snapshots the URL and commits async, so
 *  two cleanups in the same paint make the later commit resurrect the other's param. */
export function stripQueryParams(...names: string[]): void {
	if (typeof window === 'undefined') return;
	const url = new URL(window.location.href);
	if (!names.some((name) => url.searchParams.has(name))) return;
	names.forEach((name) => url.searchParams.delete(name));
	window.history.replaceState(window.history.state, '', url.toString());
}

export function openUrlInNewTab(url?: string) {
	if (typeof window === 'undefined') return;
	if (url?.startsWith('/') || url?.startsWith('blob:')) url = url;
	else if (!url?.startsWith('http')) url = `//${url}`;

	return window.open(url, '_blank');
}

export function redirectViaWindow(url?: string) {
	if (typeof window === 'undefined') return;
	if (url?.startsWith('/') || url?.startsWith('blob:')) url = url;
	else if (!url?.startsWith('http')) url = `//${url}`;

	return (window.location.href = url);
}
